import * as React from 'react';
import axios, { AxiosResponse } from 'axios';
import { IMedia } from '../../interfaces';
import config from '../../config';
import { connect } from 'react-redux';
import {showModal} from '../../actions/modal';

import { toast } from 'react-toastify';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IState {
    isLoading: boolean,
    isFavorite: boolean,
}

interface IProps extends WithTranslation {
    media: IMedia,
    auth: any,
    modal: any,
    showModal: any,
    className?: string,
    t: any
}

class Favorite extends React.Component<IProps, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            isFavorite: this.props.media.isFavorited
        };
    }

    clickHandler() {
        if (this.props.auth.isAuthentificated) {
            axios.post(`${config.host}/auth/favorite`, {
                media_id: this.props.media.media_id
            }).then((response: AxiosResponse) => {
                this.setState({
                    isFavorite: response.data.status == "added"
                });

                let text = response.data.status == "added" ? this.props.t("Добавлен в избранные") : this.props.t("Удален из избранных");
                toast(text);
            });
        } else
            this.props.showModal(this.props.t("Для добавления в список любимых Вам необходимо авторизоваться."));
    }

    render() {
        return (
            <a className={"icon " + this.props.className} onClick={(event: React.MouseEvent) => {
                event.preventDefault();

                this.clickHandler();
            }}>
                <i className={"fa fa-heart" + (this.state.isFavorite ? "" : "-o")}></i>
            </a>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        modal: state.modal,
        auth: state.auth
    };
}

export default connect(mapStateToProps, {showModal})(withTranslation()(Favorite));
